import { Routes } from '@angular/router';

import {
  ALL_ITEMS_CAN_ACTIVATE_GUARD,
  ALL_ITEMS_CAN_MATCH_GUARD
} from '@core/guards/all-items.guard';
import {
  ATTACHMENTS_CAN_ACTIVATE_GUARD,
  ATTACHMENTS_CAN_MATCH_GUARD
} from '@core/guards/attachments.guard';
import { DEFAULT_ROUTE_GUARD } from '@core/guards/default-route.guard';
import {
  FLOORPLANS_CAN_ACTIVATE_GUARD,
  FLOORPLANS_CAN_MATCH_GUARD
} from '@core/guards/floorplans.guard';
import {
  INSPECTIONS_CAN_ACTIVATE_GUARD,
  INSPECTIONS_CAN_MATCH_GUARD
} from '@core/guards/inspections.guard';
import {
  LOP_CAN_ACTIVATE_GUARD,
  LOP_CAN_MATCH_GUARD
} from '@core/guards/lop.guard';
import {
  SETTINGS_CAN_ACTIVATE_GUARD,
  SETTINGS_CAN_MATCH_GUARD
} from '@core/guards/settings.guard';
import {
  TEMPLATES_CAN_ACTIVATE_GUARD,
  TEMPLATES_CAN_MATCH_GUARD
} from '@core/guards/templates.guard';
import { ClientSetupComponent } from '@shared/components/client-setup/client-setup.component';
import { ErrorComponent } from '@shared/components/error/error.component';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found.component';
import { ProjectSetupComponent } from '@shared/components/project-setup/project-setup.component';
import { StyleGuideComponent } from '@shared/components/style-guide/style-guide.component';
import { CAN_ACTIVATE_AUTH_GUARD } from '@auth/guards/can-activate.auth.guard';
import { RESET_INSPECTION_FILTERS_GUARD } from '@inspections/guards/reset-inspection-filters.guard';

export const APP_ROUTES: Routes = [
  {
    path: ':clientId/:projectId/inspections',
    loadChildren: () =>
      import('./inspections/inspections.routes').then(
        m => m.INSPECTIONS_ROUTES
      ),
    canMatch: [INSPECTIONS_CAN_MATCH_GUARD],
    canActivate: [
      CAN_ACTIVATE_AUTH_GUARD,
      INSPECTIONS_CAN_ACTIVATE_GUARD,
      RESET_INSPECTION_FILTERS_GUARD
    ]
  },
  {
    path: ':clientId/:projectId/lop',
    loadChildren: () => import('./lop/lop.routes').then(m => m.LOP_ROUTES),
    canMatch: [LOP_CAN_MATCH_GUARD],
    canActivate: [CAN_ACTIVATE_AUTH_GUARD, LOP_CAN_ACTIVATE_GUARD],
    data: {
      title: 'LOP List'
    }
  },
  {
    path: ':clientId/:projectId/templates',
    loadChildren: () =>
      import('./templates/templates.routes').then(m => m.TEMPLATES_ROUTES),
    canMatch: [TEMPLATES_CAN_MATCH_GUARD],
    canActivate: [CAN_ACTIVATE_AUTH_GUARD, TEMPLATES_CAN_ACTIVATE_GUARD]
  },
  {
    path: ':clientId/:projectId/images',
    loadChildren: () =>
      import('./attachments/attachments.routes').then(
        m => m.ATTACHMENTS_ROUTES
      ),
    canMatch: [ATTACHMENTS_CAN_MATCH_GUARD],
    canActivate: [CAN_ACTIVATE_AUTH_GUARD, ATTACHMENTS_CAN_ACTIVATE_GUARD],
    data: {
      title: 'Images'
    }
  },
  {
    path: ':clientId/:projectId/settings',
    loadChildren: () =>
      import('./settings/settings.routes').then(m => m.SETTINGS_ROUTES),
    canMatch: [SETTINGS_CAN_MATCH_GUARD],
    canActivate: [CAN_ACTIVATE_AUTH_GUARD, SETTINGS_CAN_ACTIVATE_GUARD],
    data: {
      title: 'Settings'
    }
  },
  {
    path: ':clientId/:projectId/floorplans',
    loadChildren: () =>
      import('./floorplans/floorplans.routes').then(m => m.FLOORPLANS_ROUTES),
    canMatch: [FLOORPLANS_CAN_MATCH_GUARD],
    canActivate: [CAN_ACTIVATE_AUTH_GUARD, FLOORPLANS_CAN_ACTIVATE_GUARD],
    data: {
      title: 'Drawings'
    }
  },
  {
    path: ':clientId/:projectId/all-items',
    loadChildren: () =>
      import('./all-items/all-items.routes').then(m => m.ALL_ITEMS_ROUTES),
    canMatch: [ALL_ITEMS_CAN_MATCH_GUARD],
    canActivate: [CAN_ACTIVATE_AUTH_GUARD, ALL_ITEMS_CAN_ACTIVATE_GUARD],
    data: {
      title: 'All Items'
    }
  },
  {
    path: ':clientId/:projectId/style-guide',
    component: StyleGuideComponent,
    pathMatch: 'full',
    data: {
      title: 'Style Guide'
    }
  },
  {
    path: 'error',
    component: ErrorComponent,
    pathMatch: 'full',
    data: {
      title: 'Error'
    }
  },
  {
    path: 'client-setup',
    component: ClientSetupComponent,
    data: {
      title: 'Client Setup'
    }
  },
  {
    path: 'project-setup',
    component: ProjectSetupComponent,
    data: { title: 'Project Setup' }
  },
  {
    path: '',
    pathMatch: 'full',
    component: PageNotFoundComponent,
    canActivate: [DEFAULT_ROUTE_GUARD]
  },
  { path: '**', component: PageNotFoundComponent }
];
